import FilterMenuSearchAdvanced from "./FilterMenuSearchAdvanced";

export default FilterMenuSearchAdvanced;
